<template>
    <div class="micro-app-cop" >
        <micro-app
            name='app-cop'
            :url="config.microCopUrl"
            :data='storeInfo'
            iframe>
        </micro-app>
    </div>
</template>
<script>
import config from '@/config/user.env';
import microApp from '@micro-zoe/micro-app';
import router from '../router';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            config,
            storeInfo: {}
        };
    },
    computed: {
        ...mapGetters(['user', 'authority', 'currentTenant', 'appId', 'tenantInfo', 'appList', 'btnPermissions', 'applicationCode'])
    },
    methods: {
        initPage() {
            microApp.setData('app-cop', { path: this.$route.path, query: this.$route.query || {} });
            const {
                user,
                appId,
                authority,
                currentTenant,
                appList,
                applicationCode,
                btnPermissions } = this;

            // 这里的一些参数除了重点说明的两个一般物流的项目都会有
            this.storeInfo = {
                path: this.$route.path,
                adviceChannel: 'LSP',
                user,
                appId,
                router,
                authority: [ ...authority, { frontUrl: '/app-cop/workOrderDetails' } ],
                currentTenant,
                appList,
                applicationCode,
                btnPermissions
            };
            if (this.$route.path === '/app-cop/workOrderDetails') {
                this.$route.meta.title = '工单详情';
            }
        }
    },
    watch: {
        $route() {
            this.initPage();
        }
        // immediate: true,
    },
    mounted() {
        this.initPage();
    }

};
</script>
<style lang="less">
@import './microappTheme.less';
</style>
